import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "exchangeDollarToIQD",
})
export class ExchangeDollarToIQDPipe implements PipeTransform {
  transform(value: number, exchangeRate): number {
    if (value == null) return value;
    let result =
      Math.abs(value) * (exchangeRate ?? +localStorage.getItem("exchangeRate"));
    let remainderPrice = result % 250;
    if (remainderPrice !== 0) result = result - remainderPrice + 250;

    return value < 0 ? result * -1 : result;
  }
}
